// Reference links (TASK-1043, CONTACT-547, filenames, …) that the agent wrote
// outside backticks render as bare links. Wrap any that aren't already in a
// <code> so they pick up the same pill-chip styling as the backticked ones.
//
// Shared by the process activity stream and the task history timeline so both
// render reference chips with identical logic and styling.
export function convertReferenceChips(root) {
  if (!root) return

  // Chips from ReferenceChipHelper (.ref-chip) are already their own box; a
  // narrated line's references (.narrated-ref) stay words in their sentence.
  root.querySelectorAll("a[data-ref-type]:not(.ref-chip):not(.narrated-ref)").forEach((link) => {
    if (link.dataset.refType === "attachment") preserveAttachmentExtension(link)
    if (link.closest("code")) return
    const code = document.createElement("code")
    link.replaceWith(code)
    code.appendChild(link)
  })
}

function preserveAttachmentExtension(link) {
  if (link.querySelector(".filename-preserve-ext")) return

  const filename = link.textContent.trim()
  if (!filename) return

  const extensionIndex = filename.lastIndexOf(".")
  const hasExtension = extensionIndex > 0 && extensionIndex < filename.length - 1
  const stem = hasExtension ? filename.slice(0, extensionIndex) : filename
  const extension = hasExtension ? filename.slice(extensionIndex) : ""

  const wrapper = document.createElement("span")
  wrapper.className = "filename-preserve-ext"

  const stemElement = document.createElement("span")
  stemElement.className = "filename-stem"
  stemElement.textContent = stem
  wrapper.appendChild(stemElement)

  if (extension) {
    const extensionElement = document.createElement("span")
    extensionElement.className = "filename-ext"
    extensionElement.textContent = extension
    wrapper.appendChild(extensionElement)
  }

  link.replaceChildren(wrapper)
}
